<template>
  <el-dialog
    :visible="!!editingProject"
    title="修改设置"
    width="1000px"
    @close="closeDialog"
  >
    <el-form :model="detail" ref="form" :rules="rules" label-width="150px">
      <el-form-item label="交易对选择：" prop="pair">
        <el-select v-model="detail.pair">
          <el-option
            v-for="item in pairList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <span style="margin-left:20px;">说明：杠杆交易对不能重复哦</span>
      </el-form-item>
      <el-form-item label="爆仓风险率：" prop="burstRate">
        <el-input-number
          v-model="detail.burstRate"
          :min="0.0001"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="借贷利率：" prop="interestRate">
        <el-input-number v-model="detail.interestRate"></el-input-number>
      </el-form-item>
      <el-form-item label="最大杠杆倍数：" prop="maxMultiple">
        <el-input-number
          v-model="detail.maxMultiple"
          :min="0"
        ></el-input-number>
      </el-form-item>
      <!-- <el-form-item label="最小购买数量：" prop="minAmount">
        <el-input-number v-model="detail.minAmount"></el-input-number>
      </el-form-item> -->
      <el-form-item
        v-show="detail.pair"
        :label="`最小${detail.pair && detail.pair.split('_')[0]}借币数量：`"
        prop="coinMinAmount"
      >
        <el-input-number v-model="detail.coinMinAmount"></el-input-number>
      </el-form-item>
      <el-form-item
        v-show="detail.pair"
        :label="`最小${detail.pair && detail.pair.split('_')[1]}借币数量：`"
        prop="setMinAmount"
      >
        <el-input-number v-model="detail.setMinAmount"></el-input-number>
      </el-form-item>
      <el-form-item label="转出后最小风险率：" prop="outRate">
        <el-input-number v-model="detail.outRate"></el-input-number>
        <span style="margin-left:20px;"
          >说明：转出后杠杆账户风险率不能低于当前设置值</span
        >
      </el-form-item>
      <el-form-item label="报警风险率：" prop="warnRate">
        <el-input-number v-model="detail.warnRate"></el-input-number>
      </el-form-item>
      <el-form-item label="是否开启：" prop="open">
        <el-switch v-model="detail.open"></el-switch>
      </el-form-item>
      <el-form-item label="类型：" prop="type">
        <el-select v-model="detail.type">
          <el-option
            v-for="item in tyleList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
// import MutipleInput from '../mutipleInput';
import Upload from 'components/upload';

export default {
  name: 'cornucopiaDetail',
  data() {
    return {
      detail: {},
      tyleList: [
        { value: 1, label: '全仓' },
        { value: 2, label: '逐仓' },
        { value: 3, label: '全仓+逐仓' }
      ],
      rules: {
        pair: {
          required: true,
          message: '请填写'
        },
        burstRate: {
          required: true,
          message: '请填写'
        },
        interestRate: {
          required: true,
          message: '请填写'
        },
        maxMultiple: {
          required: true,
          message: '请填写'
        },
        coinMinAmount: {
          required: true,
          message: '请填写'
        },
        setMinAmount: {
          required: true,
          message: '请填写'
        },
        outRate: {
          required: true,
          message: '请填写'
        },
        warnRate: {
          required: true,
          message: '请填写'
        },
        open: {
          required: true,
          message: '请填写'
        },
        type: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('lever', ['pairList', 'editingProject']),
    disalbed() {
      return this.detail && this.detail.status !== 0;
    }
  },
  watch: {
    editingProject(val) {
      if (val) {
        this.detail = {
          ...val
        };
      } else {
        this.detail = {};
      }
    }
  },
  components: {
    Upload
  },
  methods: {
    ...mapMutations('lever', ['setEditingProject']),
    ...mapActions('lever', ['update']),
    closeDialog() {
      this.setEditingProject(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      const submitData = {
        ...this.detail
      };
      this.update(submitData).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh');
      });
    }
  }
};
</script>
